import React from "react";
import { LoadingIcon, Wrapper } from "./styled";

export const Button = ({
  onClick,
  width,
  variant,
  disabled,
  loading,
  type = "button",
  children,
}) => {
  return (
    <Wrapper
      onClick={onClick}
      $width={width}
      $variant={variant}
      disabled={disabled || loading}
      type={type}
    >
      {children}
      {loading && <LoadingIcon />}
    </Wrapper>
  );
};
